import { throwErrorWithId } from '@pypestream/utils';

import {
  getAgentRoutingSchemas,
  getCustomerPypes,
  getPypeConnections,
  type AgentRoutingSchema,
  type PlatformConnection,
} from '../../utils';
import { Pype } from '../prostudio.api-service.types';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

export interface CustomerPypesData {
  /** Connections themselves — the rows of the Live Agent Platforms table. */
  pypeConnections: PlatformConnection[];
  /** Still needed: resolves each bound `pypeId` to a channel name for the pills. */
  liveAgentPypes: { live: Pype[]; sandbox: Pype[] };
  agentRoutingSchemas: {
    live: AgentRoutingSchema[];
    sandbox: AgentRoutingSchema[];
  };
}

/**
 * Project-scoped (no selected bot) loader for the Live Agent Platforms settings
 * page. Distinct from `loadBotPypes`, which requires a selected solution and
 * filters pypes to it.
 */
export const loadCustomerPypes = async (
  ctx: ProStudioContext,
  _event: ProStudioEvents
): Promise<CustomerPypesData> => {
  const projectId = ctx.project?.id;
  const uniqueCustomerId = ctx.project?.projectProStudioSetting?.customerId;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
  }

  if (!uniqueCustomerId) {
    throwErrorWithId('Customer ID is required');
  }

  const [pypeConnections, liveAgentPypes, agentRoutingSchemas] =
    await Promise.all([
      getPypeConnections({ projectId: projectId! }),
      getCustomerPypes({
        uniqueCustomerId: uniqueCustomerId!,
        projectId: projectId!,
      }),
      getAgentRoutingSchemas({
        uniqueCustomerId: uniqueCustomerId!,
        projectId: projectId!,
      }),
    ]);

  return { pypeConnections, liveAgentPypes, agentRoutingSchemas };
};
